import { UiSchema } from '@rjsf/utils'
import validator from '@rjsf/validator-ajv8'
import Ajv from 'ajv'
import yaml, { YAMLException } from 'js-yaml'
import { merge } from 'lodash'
import { useEffect, useState } from 'react'

import Form, { extractUiSchema } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/components/Form'
import Monaco, { OnChange } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/components/Monaco'
import proxyAction from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/globalActions/proxy.json'
import useDatasource from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/hooks/useDatasource'
import useSearchParams from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/hooks/useSearchParams'
import { Datasource } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/interfaces'
import dump from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/utilities/dumpYaml'

export function Inputs() {
  const [datasource, setDatasource] = useDatasource(true)
  const [validSchema, setValidSchema] = useState({})

  const datasourceActions: typeof datasource.actions = { _proxy: proxyAction, ...datasource.actions }

  const [searchParams] = useSearchParams()

  const activeActionKey = searchParams.get('action')!

  const handleInputsChange: OnChange = (value = '') => {
    try {
      if (!activeActionKey) return

      const inputs = yaml.load(value) as Datasource['actions'][string]['inputs']

      setDatasource(datasource => ({
        ...datasource,
        actions: {
          ...datasource.actions,
          [activeActionKey]: {
            ...(activeActionKey === '_proxy' ? proxyAction : {}),
            ...datasource.actions[activeActionKey],
            inputs
          }
        }
      }))
    } catch (error) {
      if (error instanceof YAMLException) return
      throw error
    }
  }

  const uiSchema: UiSchema = merge(extractUiSchema(validSchema), {
    'ui:options': {
      submitButtonOptions: {
        submitText: 'Save'
      }
    }
  })

  useEffect(() => {
    const inputsSchema = datasourceActions[activeActionKey]?.inputs
    if (!inputsSchema) return

    const isSchemaValid = new Ajv().validateSchema(inputsSchema)
    if (!isSchemaValid) return

    setValidSchema(inputsSchema)
  }, [datasource])

  return (
    <>
      <div className="flex flex-1 flex-col">
        <div className="bg-gray-100 px-4 py-2 text-xs">Inputs</div>
        <Monaco
          key={activeActionKey}
          language="yaml"
          defaultValue={dump(datasourceActions[activeActionKey].inputs)}
          onChange={handleInputsChange}
        />
      </div>
      <div className="flex flex-1 flex-col">
        <div className="bg-gray-100 px-4 py-2 text-xs">Action Form Preview</div>
        <Form
          className="flex flex-1 flex-col gap-4 px-12 py-4"
          validator={validator}
          schema={validSchema || { type: 'object', properties: {}, required: [] }}
          uiSchema={uiSchema}
          formData={datasourceActions[activeActionKey].inputs}
        />
      </div>
    </>
  )
}
